import { gql } from 'Utils/apolloClient'
import InstallmentDataFragment from './installmentDataFragment'

const installmentReceiptQuery = gql`
  query InstallmentReceiptQuery($installmentId: ID!) {
    installment(uuid: $installmentId) {
      ...installmentData
    }
  }

  ${InstallmentDataFragment}`

export default installmentReceiptQuery
